module.exports = __webpack_public_path__ + "static/media/amex.df86f302.svg";